import { default as dayjs } from 'dayjs';

export const formatDate = (date: number) =>
  dayjs(date).format('MMMM D, YYYY h:mm A');

export const stringToArray = (str: string) => {
  return str.split(',');
};

export const formatNumberToK = (num?: number) => {
  if (num === undefined) {
    return '0';
  }
  if (num >= 1000) {
    return Math.round(num / 1000) + 'k';
  }
  return num.toString();
};

export const formatKey = (key: string): string => {
  const words = key
    .replace(/([A-Z])|(\d+)/g, ' $1$2')
    .toLowerCase()
    .split(' ');
  const formattedWords = words.map((word, index) =>
    index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word,
  );
  return formattedWords.join(' ');
};

export const formatMapName = (mapName?: string): string => {
  // 1) if nothing passed in, bail out
  if (!mapName) return '';

  // 2) split on underscore
  const parts = mapName.split('_');

  // 3) pick the “map” fragment: use the second piece if it exists, otherwise the first
  const raw = parts.length > 1 && parts[1] ? parts[1] : parts[0];

  // 4) finally capitalize safely
  return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
};
